import { render, staticRenderFns } from "./SelectBox3.vue?vue&type=template&id=0ee622c1&scoped=true"
import script from "./SelectBox3.vue?vue&type=script&lang=js"
export * from "./SelectBox3.vue?vue&type=script&lang=js"
import style0 from "./SelectBox3.vue?vue&type=style&index=0&id=0ee622c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee622c1",
  null
  
)

export default component.exports